import { Drawer, Flex, Text } from '@driftt/dds'
import React, { useRef, useState } from 'react'

import { formatTime } from 'utils/moment'

import { PromptContainer } from './PromptContainer'
import { TextareaWithButton } from './TextareaWithButton'
import { Validation } from './Validation'
import {
  StyledInfoContainer,
  StyledScrollbarHiddenContainer,
} from './ValidationDrawer.styles'

const ModerationDrawer = ({
  open,
  onClose,
  savedResponse,
  onAction,
}: {
  open: boolean
  onClose: () => void
  /** Text either description, guideline or exit confirmation question */
  savedResponse: string
  onAction: (prompt: string, replyGuidelines?: string) => void
}) => {
  // Local moderation moderationConfig to avoid dependency on moderationConfigByType
  const moderationConfig = {
    title: 'Response',
    buttonText: 'Use this response',
    placeholder: 'Type response here',
    info: (
      <>
        <strong>Note: </strong>
        This guardrail is maintained by Google Vertex, so be sure to enter the
        exact reply you would like your chatbot to use.
      </>
    ),
  }

  const [promptInput, setPromptInput] = useState('')
  const [currentResponse, setCurrentResponse] = useState<string>('')
  const [responseDate, setResponseDate] = useState<Date | undefined>(undefined)

  const bottomRef = useRef<null | HTMLDivElement>(null)
  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      })
    }
  }

  //Given that Moderation isn't a real "guardrail" we do not need to validate the response
  const sendResponse = () => {
    setCurrentResponse(promptInput)
    setResponseDate(new Date())
    setPromptInput('')
    scrollToBottom()
  }

  React.useEffect(() => {
    scrollToBottom()
  }, [bottomRef])

  return (
    <Drawer.Root open={open} onClose={onClose}>
      <Drawer.Dialog>
        <Drawer.Title title={moderationConfig.title} />
        <Drawer.Content>
          <StyledScrollbarHiddenContainer direction="column">
            <StyledInfoContainer>{moderationConfig.info}</StyledInfoContainer>
            {savedResponse && (
              <div>
                <Text variant="bodyBold" css={{ marginBottom: '$1' }}>
                  Current Response
                </Text>
                <PromptContainer cssStyles={{ marginBottom: '$3' }}>
                  {savedResponse}
                </PromptContainer>
              </div>
            )}
            {currentResponse && (
              <Validation
                prompt={currentResponse}
                responseDate={formatTime(responseDate, 'hh:mm A')}
                onUse={() => {
                  onClose()
                  onAction(currentResponse)
                }}
                isModeration={true}
              />
            )}
            <div ref={bottomRef}></div>
          </StyledScrollbarHiddenContainer>
        </Drawer.Content>
        <Drawer.Actions>
          <Flex direction="row" alignItems="center" width="100%">
            <TextareaWithButton
              buttonLabel="Send"
              placeholder={moderationConfig.placeholder}
              value={promptInput}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setPromptInput(e.target.value)
              }
              onClickButton={sendResponse}
            />
          </Flex>
        </Drawer.Actions>
      </Drawer.Dialog>
    </Drawer.Root>
  )
}

export default ModerationDrawer
